export const styleType = {
    PRIMARY: 1,
    SECONDARY: 2,
    SUCCESS: 3,
    DANGER: 4,
    WARNING: 5,
    INFO: 6,
    LIGHT: 7,
    DARK: 8,
    FADEBLACK: 9,
    FLEXPINK: 10
}